export default "__VITE_ASSET__DNXHJe1V__"